import { EMPTY_LIST } from '../../../../constants/common'
import { MultiValuedList } from '../../../MultiValuedList'
import { TableCellBase } from '../TableCellBase'
import { TableEmptyCell } from '../TableEmptyCell'

import * as styles from './ListCell.module.css'

function ListCell({
  List = MultiValuedList,
  children,
  count,
  done,
  listProps,
  scrollRef,
  unread,
  value,
  ...cellProps
}) {
  const items = value ?? EMPTY_LIST

  return items.length > 0 ? (
    <TableCellBase {...cellProps}>
      <List
        {...listProps}
        className={styles.list}
        done={done}
        items={items}
        itemsCount={count ?? items.length}
        moreProps={{ containerRef: scrollRef }}
        unread={unread}
      />
      {children}
    </TableCellBase>
  ) : (
    <TableEmptyCell {...cellProps} unread={unread} />
  )
}

export default ListCell
